import { useState } from "react";
import "@/styles/Layout.scss";
import apiClient from "@/services";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

function Unsubscribe() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleUnsubscribe = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage("");

    try {
      const response = await apiClient.get(
        `/preferences?type=email&identifier=${encodeURIComponent(email)}`
      );

      if (response.status === 200) {
        setMessage("You have been successfully unsubscribed from our emails.");
      } else {
        setMessage(response.data?.message || "Unsubscribe request processed");
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setMessage("Email not found in our system");
      } else {
        setMessage("An unexpected error occurred");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="sectionWrapper">
      <div className="welcome-message p-6 flex flex-col">
        <h2 className="text-lg font-semibold mb-0">Unsubscribe from Emails</h2>
        <p className="text-muted text-base leading-loose mb-2">
          We're sorry to see you go. Enter your email address below to
          unsubscribe from all future communications from JP Associates.
        </p>

        <form onSubmit={handleUnsubscribe}>
          <div className="grid w-full max-w-sm items-center gap-3 mt-2">
            <Label htmlFor="email" className="text-muted ms-0.5">
              Email Address
            </Label>

            <Input
              type="email"
              id="email"
              value={email}
              placeholder="Enter your email"
              className="w-full h-[50px] mb-3"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <Button
            type="submit"
            disabled={!email || isSubmitting}
            className="w-full max-w-sm h-[50px] text-white mt-1.5 bg-green"
          >
            {isSubmitting ? "Processing..." : "Unsubscribe"}
          </Button>
        </form>

        {message && (
          <p
            className={`mt-4 text-sm ${
              message.includes("successfully")
                ? "text-green-500"
                : "text-red-500"
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
}

export default Unsubscribe;
